import { useMemo } from 'react'

import {
  TicketingResolverTeamsDocument,
  type TicketingResolverTeamsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import type { TeamOption } from 'modules/ticketing/hooks/useMyTeams'

/**
 * Returns all resolver teams configured for ticketing.
 * Used in the ticket list filter to show only teams that can resolve tickets.
 */
export const useResolverTeams = (): {
  teams: TeamOption[]
  loading: boolean
  error?: unknown
} => {
  const { data, loading, error } = useQuery<TicketingResolverTeamsQuery, Record<string, never>>(
    TicketingResolverTeamsDocument,
    {
      fetchPolicy: 'cache-and-network',
    }
  )

  const teams = useMemo<TeamOption[]>(() => {
    return (data?.ticketing?.resolverTeamsConnection?.nodes ?? []).flatMap((node) => {
      if (node.teamId == null || node.teamName == null) {
        return []
      }

      return [
        {
          label: node.teamName,
          value: String(node.teamId),
        },
      ]
    })
  }, [data?.ticketing?.resolverTeamsConnection?.nodes])

  return { teams, loading, error }
}
